import clsx from "clsx";
/**
 * BEM helper function to generate class names. Powered by clsx.
 *
 * @param block - The base block name.
 * @param modifiers - Additional modifiers or boolean flags to apply.
 * @returns A string of class names based on the provided block and modifiers.
 *
 * @example
 * ```ts
 * bemby("button", "primary", { disabled: true })
 * // returns "button button--primary button--disabled"
 * ```
 */ export default function bemby(block, ...modifiers) {
  return clsx(block, modifiers.map(function handle(modifier) {
    if (typeof modifier === "string") {
      if (modifier.match(/\s+/)) {
        return modifier.split(/\s+/).map(handle);
      }
      return `${block}--${modifier}`;
    } else if (Array.isArray(modifier)) {
      return modifier.map(handle);
    } else if (typeof modifier === "object") {
      return Object.entries(modifier).map(([key, value])=>{
        if (value) {
          return `${block}--${key}`;
        }
        return false;
      });
    }
  }));
}
//# sourceMappingURL=bemby.js.map